import localeText from "../../../../../locale";
import { localeISO } from "../../../../../utilities/localeIso";

const formatNumber = (value) => (value ?? 0).toLocaleString(localeISO);

// Barras horizontais de uma série só: o total fica no cabeçalho, não como mais uma barra
const UsersByTypeChart = ({ data, loading }) => {
  const rows = [
    { label: "Managers", value: data?.amountManagers },
    { label: "Sellers", value: data?.amountSellers },
    { label: "Partners", value: data?.amountPartners },
    { label: "Customers", value: data?.amountCustomers },
    { label: "Promoters", value: data?.amountPromoters },
  ].map((row) => ({ ...row, value: row.value || 0 }));

  const total = rows.reduce((sum, row) => sum + row.value, 0);
  const max = Math.max(...rows.map((row) => row.value), 1);

  return (
    <section className="admin-home-card">
      <header className="admin-home-card__header">
        <div>
          <h2 className="admin-home-card__title">{localeText("usersOfSystem")}</h2>
          <p className="admin-home-card__subtitle">
            {loading ? "…" : `${formatNumber(total)} ${localeText("adminHomeTotalUsers")}`}
          </p>
        </div>
      </header>

      <ul className="admin-home-bars" aria-busy={loading}>
        {rows.map((row) => {
          const share = total ? Math.round((row.value / total) * 100) : 0;
          return (
            <li
              key={row.label}
              className="admin-home-bars__row"
              title={`${row.label}: ${formatNumber(row.value)} (${share}%)`}
            >
              <span className="admin-home-bars__label">{row.label}</span>
              <span className="admin-home-bars__track">
                {!loading && (
                  <span
                    className="admin-home-bars__fill"
                    style={{ width: `${(row.value / max) * 100}%` }}
                  />
                )}
              </span>
              <span className="admin-home-bars__value">
                {loading ? "" : formatNumber(row.value)}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default UsersByTypeChart;
